module.exports = __webpack_public_path__ + "img/winery_image.528230f3.png";